import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-RO-logo_svg__layer",
  viewBox: "0 0 258.8 184.2"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-RO-logo_svg__cls-2{fill-rule:evenodd;fill:#003a87}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m170.6.1-1.2.4-1.2.7-1.1.9-2.2 2-2.1 2.2L1.1 177.5l-.7 1.1-.4 1.1.1 1.1.5 1 .8.9 1 .8 1.1.5 1.4.1H153l1.5-.1 1.3-.3 1.3-.7 1.3-.8 1.2-.9 1-1.1.9-1.2L233.7 6.5l.4-1.3.1-1.1-.1-1.1-.3-1c0-.1-.7-.8-.7-.8l-.9-.6-1-.5c-.1 0-1.3-.1-1.3-.1h-58.1l-1.2.1M247.8.1s-.1.1-.1.3h.2s-77.2 183.7-77.3 183.8h10.6c.2-.1 77.6-183.8 77.6-183.8l-11-.3",
      class: "svg-RO-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M134.6 64.2c24.1 0 43.6 19.7 43.6 43.7s-19.5 43.9-43.6 43.9-44-19.7-44-43.9c.1-24.1 19.8-43.7 44-43.7m-17.8 55.2c-3.5-.4-5.5-1-8.4-.7-3.3.3-7.8 3.2-10.6 6.3-2.4-5.2-3.7-11-3.7-17.2 0-22.2 18.1-40.4 40.5-40.4 9.5 0 18.5 3.5 25.5 9.2l-43.3 42.8Zm15 2.7 37.3 6.8c3.8-6.2 5.8-13.2 5.8-21 0-11.8-5.2-22.5-13.4-30l-29.7 44.2Zm1.8 6.2 18.8 15.4-34.8-17.2c-3.2-.9-6.3-1.1-9.2-1.2-3.4-.1-6.5.4-10 1 6.8 13.1 20.5 22.1 36.3 22.1 13.8 0 26.2-7.1 33.5-18.1l-34.6-2Z",
      style: {"fill-rule":"evenodd","fill":"#fff"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "RO-logo"}) } }